
$(window).on('load', function () {
	initTabs();
	if (localStorage.getItem('back-btn-clicked')) {
		var tabOpened = localStorage.getItem('openedTab');
		var referPage = document.referrer.replace(/^[^:]+:\/\/[^/]+/, '').replace(/#.*/, '').includes("/members/");

		if (tabOpened === '1' && referPage == true) {
			$("a[data-index='1']").trigger('click');
			$(".select-menu-outer ul li[data-value='1']").trigger('click');
		}
		if (tabOpened === '3' && referPage == true) {
			$("a[data-index='3']").trigger('click');
			$(".select-menu-outer ul li[data-value='3']").trigger('click');
		}
	}
	localStorage.removeItem('openedTab')
	$('.member a').on('click', e => {
		let currTab = $('.team-tabs__tab.active')
		let tab = $(currTab).data('index');
		let isMobileScreen = window.matchMedia("(max-width: 767px)")
		if (isMobileScreen.matches) {
			let currSelect = $('.select-menu-outer ul li.active');
			tab = $(currSelect).data('value');
		}
		localStorage.setItem('openedTab', tab)

	})
});

function initTabs() {
	const tabs = $('.team-tabs.desktop .team-tabs__tab');
	const tabsContent = $('.team-slider');
	if (tabs.length) {
		tabs.off('click').on('click', function (e) {
			e.preventDefault();
			if (!$(this).hasClass('active')) {
				const index = $(this).attr('data-index');
				const tabContent = $('.team-slider[data-index="' + index + '"]');
				tabs.removeClass('active');
				tabsContent.removeClass('active');
				$(this).addClass('active');
				tabContent.addClass('active');
			}
		});

		$(window).on('click', function () {
			$('.select-wrapper').removeClass('is-open')
		});

		const mobileSelectItems = $('.select-wrapper .select-menu-outer li');

		if (mobileSelectItems.length) {
			// initially active first menu item
			$('.select-wrapper').each((index, item) => {
				let firstMenuVal = $(item).find('.select-menu-outer ul li:first-child').attr('data-value')
				let fistMenuChild = $(item).find('.select-menu-outer ul li:first-child').html();
				$(item).find('.select-control input').val(firstMenuVal);
				$(item).find('.select-control .select-value').html(fistMenuChild)
			})
			// select outside click event

			$('.select-control').on('click', (e) => {
				e.stopPropagation();
				let selectWrapper = e.target.closest('.select-wrapper');
				$(selectWrapper).toggleClass('is-open');
			})
			$('.select-menu-outer ul li').on('click', function (e) {
				e.stopPropagation();
				let selectWrapper = e.target.closest('.select-wrapper');
				let value = $(e.target).attr('data-value');
				let child = $(e.target).html();

				const tabContent = $('.team-slider[data-index="' + value + '"]');
				tabsContent.removeClass('active');
				tabContent.addClass('active');

				$('.select-menu-outer ul li').removeClass('active')
				$(this).addClass('active');

				let selectInput = $(selectWrapper).find('.select-control input')
				let selectValue = $(selectWrapper).find('.select-control .select-value')
				$(selectInput).val(value)
				$(selectValue).html(child)

				$(selectWrapper).removeClass('is-open');
			})
		}
	}
}
